// 拉取礼物信息
import giftopb from './giftomall-giftlist.pb';
import publicpb from './resultresponse.pb';
import PbAjax from '../../../lib/pbajax';
let Code = publicpb.Code;
let pbajax = new PbAjax();
let gifto = {

    getList() {

        let promise = $.Deferred();
        let {Request,Response } = giftopb.Gifto.Mall.GiftList;
        pbajax.do(
            {
                service: 'gifto_mall',    
                api: '/gifto/mall/gift/list',  
                header: {
                    userToken: UP.Global.getUserToken(),
                    'Accept-Language': UP.Global.siteLanguage
                    // UserAgent: UserAgent + (window.smDeviceId ? (' smd/' + window.smDeviceId) : '') // 礼物列表，后端会判断版本号，根据版本号给出礼物列表
                    // UserAgent: 
                },
                
            }, 

            null, 

            (res)=>{
                var dataWrap = publicpb.Result.decode(res);

                if (dataWrap.code == Code.GIFTO_MALL_REQUEST_SUCCESS) {

                    let data = Response.decode(dataWrap.data.value);
                    if (data.batchSendConfigs.length == 0) {
                        data.batchSendConfigs = [{
                            amount: 1,
                            description: null
                        }];
                    }
                    this.data = data;
                    promise.resolve(data);

                } else if (dataWrap.code == 8192) {
                    // global.login();
                }

            }, 
            ()=>{
                promise.fail();
            }, 
            ()=>{

                promise.fail();
            }
        );
        return promise;
    },

    getOnlineGift() {
        let list = this.data.gifts;
        let result = [];
        let whiteTypeList  = [1, 12, 6, 7, 16, 24];
        /**
            type 礼物类型：
            1: 静态；2:动态；3:弹幕; 4:文本翻译; 5: 弹幕翻译; 6:精灵; 7:精灵球; 8:点击精灵; 
            9: 宝箱; 10:守护; 11: goole翻译; 12:大动画; 13: 红包; 14: 悄悄话; 15:悄悄话翻译;
            16:新手引导礼物; 17:免费礼物; 19:全区喇叭; 23: 免费无时限装饰; 24:用户打赏装饰; 25:七彩弹幕
            26: 动画弹幕; 27:视频贴纸
         */ 

        for (let i = 0, len = list.length; i < len; i++) {
            let item = list[i];
            
            item.guardLevel = item.guardLevel || 0;
            
            // 屏蔽金币和美金等U钻礼物，type=1  && item.produceType == 2。添加的是U钻 && item.productType=3 Gifto
            if (item.currencyInfo.giftoCurrencyCode == 'GTO' && item.onLined && item.produceType == 3 && (whiteTypeList.indexOf(item.type) > -1) && item.guardLevel == 0 ) {
                item.pic = this.getGiftPicFromId(item.giftId);
                item.price = item.price || 0;
                result.push(item);
            }

            
        }
        
        return result;
    },

    // 从在线礼物列表中获取 大礼物图片列表
    // 要排除canCombo的连发图片（不会播大动画）
    getBigGiftPicList() {
        let onlineList = this.getOnlineGift();
        let picList = [];
        for (var i = onlineList.length; i--;) {
            let item = onlineList[i];
            if (item.canCombo) {
                continue;
            }
            picList.push(this.getNormalPic(item.resources).big)
        }

        return picList;
    },

    // 价值为10的礼物
    getOnlineCheapGift() {
        let onlineList = this.getOnlineGift();

        let list = [];
        
        for (var len = onlineList.length, i = 0; i < len; i++) {
            let item = onlineList[i];
            
            if (parseInt(item.price, 10)  == 10) {
                list[list.length] = item;
            }
        }

        return list;
    },  

    // 换算成二维数组
    formatDyadicArray(arr) {
        let result = [];
        let unitCount = 8;
        for (let i = 0, len = arr.length; i < len; i += 8) {
            result.push(arr.slice(i, i+unitCount));
        }
        return result;
    },

    getGiftFromId(giftId) {
        if (!this.data) {
            return;
        }
        let result;
        let gifts = this.data.gifts;

        for (let i = gifts.length; i--;) {
            let item = gifts[i];
            if (item.giftId == giftId) {
                result = {...item};
                break;
            }

        }
        
        return result;
    },

    // 根据礼物id查询礼物图片, 包括big、samll
    getGiftPicFromId(giftId) {
        if (!this.data) {
            return;
        }
        let gift = this.getGiftFromId(giftId);

        if (!gift) {
            return;
        }

        let pic = this.getNormalPic(gift.resources);
        
        return pic;
    },

    // http://g.cdn.upliveapps.com/oauthgame/88806_CN_1484828468_mozilla_
    // getNormalPic(str) {
    //     // ["http://g.cdn.upliveapps.com/oauthgame/88806", "CN", "1484828468", "mozilla", ""]
    //     let arr = str.split('_');
    //     let target = arr[arr.length - 2];
    //     let prefix = str.replace(target, 'android');

    //     return {
    //         big: prefix + 'big.png',
    //         small: prefix + 'small.png',
    //         webp: {
    //             big: prefix + 'big.webp',
    //             middle: prefix + 'middle.webp',
    //             small: prefix + 'small.webp'
    //         }
    //     };
    // },
    // type 1：大图，2：中图，3：小图，4：大动画，5：中动画，6：小动画，7：声音
    getNormalPic(resources) {
        let ret = {};

        resources.forEach((item) => {
            switch (item.type) {
                case 1:
                    ret.big = item.url;
                    break;
                case 2:
                    ret.middle = item.url;
                    break;
                case 3:
                    ret.small = item.url;
                    break;
                case 4:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.big = item.url;
                    break;
                case 5:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.middle = item.url;
                    break;
                case 6:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.small = item.url;
                    break;
                case 7:
                    ret.voice = item.url;
                    break;
                case 9:
                    ret.webpObj = {
                        json: item.json,
                        imgs: item.url.split(','),
                    };
                    break;
            }
        });
        
        return ret;
    },

    // 预加载大图片
    preLoadBigPic() {
        // let allpic = this.getBigGiftPicList();

        // let preload = (inx)=>{
        //     if (inx >= allpic.length) {
        //         return;
        //     }
        //     let img = new Image();
        //     img.src = allpic[inx];
        //     if (img.complete) {
        //         preload(inx + 1);
        //     } else {
        //         img.onload = function() {
        //             preload(inx + 1);
        //         }
        //     }
        // };

        // preload(0);
    }

};

export default gifto;


// WEBPACK FOOTER //
// ./js/living/gift/gto/giftomall-giftlist.js